import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord, StateModel } from '@common/models';

export interface ISalesPackagePriceRuleStateModel extends IModel {
  salesPackagePriceRuleStateId: number;
  salesPackagePriceRuleId: number;
  stateId: number;
  state: StateModel;
}

export class SalesPackagePriceRuleStateModel
  extends Model
  implements ModelRecord<ISalesPackagePriceRuleStateModel>
{
  salesPackagePriceRuleStateId: number;
  salesPackagePriceRuleId: number;
  stateId: number;
  state: StateModel;
  constructor(params?: Partial<ISalesPackagePriceRuleStateModel>) {
    super(params);
    this.salesPackagePriceRuleStateId = defaultTo(
      params?.salesPackagePriceRuleStateId,
      0,
    );
    this.salesPackagePriceRuleId = defaultTo(
      params?.salesPackagePriceRuleId,
      0,
    );
    this.stateId = defaultTo(params?.stateId, 0);
    this.state = params?.state
      ? new StateModel(params.state)
      : new StateModel();
  }
}
